import { CSSProperties, MouseEventHandler, PropsWithChildren } from 'react';
import { css, cx } from '@emotion/css';
import { useTheme } from '@tcc-online/react-theme-provider';
import styles from './BaseCard.module.scss';

interface BaseCardProps {
    className?: string;
    onClick?: MouseEventHandler<HTMLDivElement>;
    style?: CSSProperties;
}

export default function BaseCard(props: PropsWithChildren<BaseCardProps>) {
    const { children, className, onClick, style } = props;
    const [theme] = useTheme();

    return (
        <div
            className={cx(
                styles.card,
                css({ background: theme.surfaceColor }),
                className,
            )}
            style={style}
            onClick={onClick}
        >
            {children}
        </div>
    );
}
